import { useEffect, useState } from "react";
import { CustomDateField } from "../../../components/CustomDateField";
import moment from "moment";
import { getCustomerServices } from "../../../services/Services";
import useConfirm from "../../../hook/useConfirm";
import axios from "axios";
import { baseURL } from "../../../config/api";
import { getLoctionOpenHours } from "../../../services/Appointment";

type DatesProps = {
    goToNextPage: () => void;
    getDataFromDateAndService: (
        inputServiceDate: string,
        inputServiceTime: string,
        selectedServices: number[],
        serviceLocationId: number,
        serviceLocationAddress: string,
        serviceLocationLink: string
    ) => void;
    selectedDate: string;
    selectedTime: string;
    allServices: any[];
    primaryKey: number;
    locationId: number;
    locationAddress: string;
    locationLink: string;
    locationOptions: any[];
    setPleaseWaitPopup: (value: boolean) => void;
    status: string
}

export const Dates = ({
    goToNextPage,
    getDataFromDateAndService,
    selectedDate,
    selectedTime,
    allServices,
    primaryKey,
    locationId,
    locationAddress,
    locationLink,
    locationOptions,
    setPleaseWaitPopup,
    status
}: DatesProps) => {
    const [locationOpenHour, setLocationOpenHour] = useState<any[]>([]);
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const [serviceLocationId, setServiceLocationId] = useState<number>(0);
    const [serviceLocationAddress, setServiceLocationAddress] = useState<string>("");
    const [serviceLocationLink, setServiceLocationLink] = useState<string>("");
    const [serviceDate, setServiceDate] = useState(moment().format("YYYY-MM-DD"));
    const [serviceTime, setServiceTime] = useState<string>(moment().format('HH:mm'));
    const [servicesOptions, setServicesOptions] = useState<any[]>([]);
    const [serviceOptionsLoaded, setServiceOptionsLoaded] = useState<boolean>(false);
    const [selectedServices, setSelectedServices] = useState<any[]>([]);
    const [blockDaysCheckWarning, setBlockDaysCheckWarning] = useState<string | null>(null);

    useEffect(() => {
        setServiceOptionsLoaded(false);
        getCustomerServices()
            .then((data) => {
                setServicesOptions(data?.reverse())
                setServiceOptionsLoaded(true);
            }).catch((error) => {
                setServicesOptions([]);
                console.error(error);
            })
    }, [])

    useEffect(() => {
        if (serviceLocationId > 0) {
            getLoctionOpenHours(serviceLocationId)
                .then(data => {
                    setLocationOpenHour(data?.filter((item: any) => new Date(item.startDate) <= new Date() && new Date(item.endDate) >= new Date()));
                })
                .catch((error) => {
                    setLocationOpenHour([]);
                    console.error(error);
                })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [serviceLocationId]);



    useEffect(() => {
        setServiceDate(selectedDate);
        setServiceTime(selectedTime);
        setSelectedServices(allServices);
        setServiceLocationId(locationId);
        setServiceLocationAddress(locationAddress);
        setServiceLocationLink(locationLink);
    }, [primaryKey, selectedDate, selectedTime, allServices, locationId, locationAddress, locationLink])


    useEffect(() => {
        const startDateTime = moment(`${serviceDate}T${serviceTime}`).format('YYYY-MM-DDTHH:mm');
        const endDateTime = moment(`${serviceDate}T${serviceTime}`).format('YYYY-MM-DDTHH:mm');
        setPleaseWaitPopup(true);
        axios.get(`${baseURL}blockedDays/GetBlockedDaysByStartDateAndEndDate/${startDateTime},${endDateTime}`)
            .then((res) => {
                setPleaseWaitPopup(false);
                if (res.data.length > 0) {
                    if (res.data[0]?.isAllDay) {
                        setBlockDaysCheckWarning(`We are closed on ${moment(serviceDate).format("MM/DD/YYYY")} please choose different date.`)
                    }
                    else {
                        setBlockDaysCheckWarning(`We are closed on ${moment(serviceDate).format("MM/DD/YYYY")} between ${moment(res.data[0]?.startTime, "HH:mm").format("hh:mm A")} to ${moment(res.data[0]?.endTIme, "HH:mm").format("hh:mm A")}  please choose different time.`)
                    }
                }
                else {
                    let openHourWarning = "";
                    if (locationOpenHour.length > 0) {
                        switch (new Date(serviceDate.replaceAll("-", "/")).getDay()) {
                            case 0:
                                if (locationOpenHour[0].isSundayOpen) {
                                    openHourWarning = ""
                                    if (
                                        locationOpenHour[0].sundayOpenTime <=
                                        serviceTime &&
                                        locationOpenHour[0].sundayCloseTime >=
                                        serviceTime
                                    ) {
                                        openHourWarning = ""
                                    }
                                    else {
                                        openHourWarning = "We are open on Sunday from " +
                                            moment(locationOpenHour[0].sundayOpenTime, "HH:mm").format("hh:mm a") +
                                            " to " +
                                            moment(locationOpenHour[0].sundayCloseTime, "HH:mm").format("hh:mm a");
                                    }
                                } else {
                                    openHourWarning = "We are closed on Sunday";
                                }
                                break;
                            case 1:
                                if (locationOpenHour[0].isMondayOpen) {
                                    openHourWarning = ""
                                    if (
                                        locationOpenHour[0].mondayOpenTime <=
                                        serviceTime &&
                                        locationOpenHour[0].mondayCloseTime >=
                                        serviceTime
                                    ) {
                                        openHourWarning = ""
                                    }
                                    else {
                                        openHourWarning = "We are open on Monday from " +
                                            moment(locationOpenHour[0].mondayOpenTime, "HH:mm").format("hh:mm a") +
                                            " to " +
                                            moment(locationOpenHour[0].mondayCloseTime, "HH:mm").format("hh:mm a");
                                    }
                                } else {
                                    openHourWarning = "We are closed on Monday";
                                }
                                break;
                            case 2:
                                if (locationOpenHour[0].isTuesdayOpen) {
                                    openHourWarning = ""
                                    if (
                                        locationOpenHour[0].tuesdayOpenTime <=
                                        serviceTime &&
                                        locationOpenHour[0].tuesdayCloseTime >=
                                        serviceTime
                                    ) {
                                        openHourWarning = ""
                                    }
                                    else {
                                        openHourWarning = "We are open on Tuesday from " +
                                            moment(locationOpenHour[0].tuesdayOpenTime, "HH:mm").format("hh:mm a") +
                                            " to " +
                                            moment(locationOpenHour[0].tuesdayCloseTime, "HH:mm").format("hh:mm a");
                                    }
                                } else {
                                    openHourWarning = "We are closed on Tuesday";
                                }
                                break;
                            case 3:
                                if (locationOpenHour[0].isWednesdayOpen) {
                                    openHourWarning = ""
                                    if (
                                        locationOpenHour[0].wednesdayOpenTime <=
                                        serviceTime &&
                                        locationOpenHour[0].wednesdayCloseTime >=
                                        serviceTime
                                    ) {
                                        openHourWarning = ""
                                    }
                                    else {
                                        openHourWarning = "We are open on Wednesday from " +
                                            moment(locationOpenHour[0].wednesdayOpenTime, "HH:mm").format("hh:mm a") +
                                            " to " +
                                            moment(locationOpenHour[0].wednesdayCloseTime, "HH:mm").format("hh:mm a");
                                    }
                                } else {
                                    openHourWarning = "We are closed on Wednesday";
                                }
                                break;
                            case 4:
                                if (locationOpenHour[0].isThursdayOpen) {
                                    openHourWarning = ""
                                    if (
                                        locationOpenHour[0].thursdayOpenTime <=
                                        serviceTime &&
                                        locationOpenHour[0].thursdayCloseTime >=
                                        serviceTime
                                    ) {
                                        openHourWarning = ""
                                    }
                                    else {
                                        openHourWarning = "We are open on Thursday from " +
                                            moment(locationOpenHour[0].thursdayOpenTime, "HH:mm").format("hh:mm a") +
                                            " to " +
                                            moment(locationOpenHour[0].thursdayCloseTime, "HH:mm").format("hh:mm a");
                                    }
                                } else {
                                    openHourWarning = "We are closed on Thursday";
                                }
                                break;
                            case 5:
                                if (locationOpenHour[0].isFridayOpen) {
                                    openHourWarning = ""
                                    if (
                                        locationOpenHour[0].fridayOpenTime <=
                                        serviceTime &&
                                        locationOpenHour[0].fridayCloseTime >=
                                        serviceTime
                                    ) {
                                        openHourWarning = ""
                                    }
                                    else {
                                        openHourWarning = "We are open on Friday from " +
                                            moment(locationOpenHour[0].fridayOpenTime, "HH:mm").format("hh:mm a") +
                                            " to " +
                                            moment(locationOpenHour[0].fridayCloseTime, "HH:mm").format("hh:mm a");
                                    }
                                } else {
                                    openHourWarning = "We are closed on Friday";
                                }
                                break;
                            case 6:
                                if (locationOpenHour[0].isSaturdayOpen) {
                                    openHourWarning = ""
                                    if (
                                        locationOpenHour[0].saturdayOpenTime <=
                                        serviceTime &&
                                        locationOpenHour[0].saturdayCloseTime >=
                                        serviceTime
                                    ) {
                                        openHourWarning = ""
                                    }
                                    else {
                                        openHourWarning = "We are open on Saturday from " +
                                            moment(locationOpenHour[0].saturdayOpenTime, "HH:mm").format("hh:mm a") +
                                            " to " +
                                            moment(locationOpenHour[0].saturdayCloseTime, "HH:mm").format("hh:mm a");
                                    }
                                } else {
                                    openHourWarning = "We are closed on Saturday";
                                }
                                break;
                        }
                    }
                    if (openHourWarning === "") {
                        setBlockDaysCheckWarning("");
                    }
                    else {
                        setBlockDaysCheckWarning(openHourWarning);
                    }
                }
            })
            .catch((error) => {
                console.error(error)
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [serviceDate, serviceTime, locationOpenHour])


    const toggleService = (service: any) => {
        if (!primaryKey || status === "Scheduled" || status === "Queued" || status === "InProgress") {
            setSelectedServices((prev) => {
                const exists = prev.some(
                    (s: any) => s.id === service.serviceID
                );

                if (exists) {
                    return prev.filter((s: any) => s.id !== service?.serviceID);
                }

                return [...prev, {
                    id: service?.serviceID,
                    additionalAppointmentServiceID: 0,
                    requiresTireCount: service?.requiresTireCount,
                    price: service?.price,
                    serviceName: service?.serviceName,
                    inventoryType: service?.inventoryType,
                    quantity: 1
                }];

            });
        }
    };

    const handleNext = () => {
        if (!primaryKey || status === "Scheduled" || status === "Queued" || status === "InProgress") {
            if (!selectedServices.length) {
                setConfirmPopup(true);
                setConfirmData({
                    title: "Please select a service.",
                    confirmBtn: "Ok",
                    isConfirm: (callback: any) => {
                        callback();
                    }
                })
                return;
            }

            const startDateTime = moment(`${serviceDate}T${serviceTime}`).format('YYYY-MM-DDTHH:mm');
            const endDateTime = moment(`${serviceDate}T${serviceTime}`).format('YYYY-MM-DDTHH:mm');
            setPleaseWaitPopup(true);
            axios.get(`${baseURL}blockedDays/GetBlockedDaysByStartDateAndEndDate/${startDateTime},${endDateTime}`)
                .then((res) => {
                    setPleaseWaitPopup(false);
                    if (res.data.length > 0) {
                        if (res.data[0]?.isAllDay) {
                            setConfirmPopup(true);
                            setConfirmData({
                                title: `We are closed on ${moment(serviceDate).format("MM/DD/YYYY")} please choose different date.`,
                                confirmBtn: "Ok",
                                isConfirm: (callback: any) => {
                                    callback();
                                }
                            })
                            return;
                        }
                        else {
                            setConfirmPopup(true);
                            setConfirmData({
                                title: `We are closed on ${moment(serviceDate).format("MM/DD/YYYY")} between ${moment(res.data[0]?.startTime, "HH:mm").format("hh:mm A")} to ${moment(res.data[0]?.endTIme, "HH:mm").format("hh:mm A")}  please choose different time.`,
                                confirmBtn: "Ok",
                                isConfirm: (callback: any) => {
                                    callback();
                                }
                            })
                            return;
                        }
                    }
                    else {
                        let openHourWarning = "";
                        if (locationOpenHour.length > 0) {
                            switch (new Date(serviceDate.replaceAll("-", "/")).getDay()) {
                                case 0:
                                    if (locationOpenHour[0].isSundayOpen) {
                                        openHourWarning = ""
                                        if (
                                            locationOpenHour[0].sundayOpenTime <=
                                            serviceTime &&
                                            locationOpenHour[0].sundayCloseTime >=
                                            serviceTime
                                        ) {
                                            openHourWarning = ""
                                        }
                                        else {
                                            openHourWarning = "We are open on Sunday from " +
                                                moment(locationOpenHour[0].sundayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHour[0].sundayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        openHourWarning = "We are closed on Sunday";
                                    }
                                    break;
                                case 1:
                                    if (locationOpenHour[0].isMondayOpen) {
                                        openHourWarning = ""
                                        if (
                                            locationOpenHour[0].mondayOpenTime <=
                                            serviceTime &&
                                            locationOpenHour[0].mondayCloseTime >=
                                            serviceTime
                                        ) {
                                            openHourWarning = ""
                                        }
                                        else {
                                            openHourWarning = "We are open on Monday from " +
                                                moment(locationOpenHour[0].mondayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHour[0].mondayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        openHourWarning = "We are closed on Monday";
                                    }
                                    break;
                                case 2:
                                    if (locationOpenHour[0].isTuesdayOpen) {
                                        openHourWarning = ""
                                        if (
                                            locationOpenHour[0].tuesdayOpenTime <=
                                            serviceTime &&
                                            locationOpenHour[0].tuesdayCloseTime >=
                                            serviceTime
                                        ) {
                                            openHourWarning = ""
                                        }
                                        else {
                                            openHourWarning = "We are open on Tuesday from " +
                                                moment(locationOpenHour[0].tuesdayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHour[0].tuesdayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        openHourWarning = "We are closed on Tuesday";
                                    }
                                    break;
                                case 3:
                                    if (locationOpenHour[0].isWednesdayOpen) {
                                        openHourWarning = ""
                                        if (
                                            locationOpenHour[0].wednesdayOpenTime <=
                                            serviceTime &&
                                            locationOpenHour[0].wednesdayCloseTime >=
                                            serviceTime
                                        ) {
                                            openHourWarning = ""
                                        }
                                        else {
                                            openHourWarning = "We are open on Wednesday from " +
                                                moment(locationOpenHour[0].wednesdayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHour[0].wednesdayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        openHourWarning = "We are closed on Wednesday";
                                    }
                                    break;
                                case 4:
                                    if (locationOpenHour[0].isThursdayOpen) {
                                        openHourWarning = ""
                                        if (
                                            locationOpenHour[0].thursdayOpenTime <=
                                            serviceTime &&
                                            locationOpenHour[0].thursdayCloseTime >=
                                            serviceTime
                                        ) {
                                            openHourWarning = ""
                                        }
                                        else {
                                            openHourWarning = "We are open on Thursday from " +
                                                moment(locationOpenHour[0].thursdayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHour[0].thursdayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        openHourWarning = "We are closed on Thursday";
                                    }
                                    break;
                                case 5:
                                    if (locationOpenHour[0].isFridayOpen) {
                                        openHourWarning = ""
                                        if (
                                            locationOpenHour[0].fridayOpenTime <=
                                            serviceTime &&
                                            locationOpenHour[0].fridayCloseTime >=
                                            serviceTime
                                        ) {
                                            openHourWarning = ""
                                        }
                                        else {
                                            openHourWarning = "We are open on Friday from " +
                                                moment(locationOpenHour[0].fridayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHour[0].fridayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        openHourWarning = "We are closed on Friday";
                                    }
                                    break;
                                case 6:
                                    if (locationOpenHour[0].isSaturdayOpen) {
                                        openHourWarning = ""
                                        if (
                                            locationOpenHour[0].saturdayOpenTime <=
                                            serviceTime &&
                                            locationOpenHour[0].saturdayCloseTime >=
                                            serviceTime
                                        ) {
                                            openHourWarning = ""
                                        }
                                        else {
                                            openHourWarning = "We are open on Saturday from " +
                                                moment(locationOpenHour[0].saturdayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHour[0].saturdayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        openHourWarning = "We are closed on Saturday";
                                    }
                                    break;
                            }
                        }
                        if (openHourWarning === "") {
                            getDataFromDateAndService(serviceDate, serviceTime, selectedServices, serviceLocationId, serviceLocationAddress, serviceLocationLink);
                            goToNextPage();
                        }
                        else {
                            setConfirmPopup(true);
                            setConfirmData({
                                title: openHourWarning,
                                confirmBtn: "Ok",
                                isConfirm: (callback: any) => {
                                    callback();
                                }
                            })
                            return;
                        }
                    }
                })
                .catch((error) => {
                    console.error(error)
                })
        }
        else {
            goToNextPage();
        }
    }


    return (
        <div className="w-full mt-2">
            <div className={`w-full pb-4`}>
                <div className="flex">
                    <div className="mt-2 p-2 w-[50%]">
                        {
                            locationOptions.length > 1 && (
                                <div className="border-b pb-4 space-y-4">

                                    {/* Title */}
                                    <span className="text-sm font-semibold text-gray-800">
                                        Choose Location
                                    </span>
                                    <div>
                                        <select
                                            value={serviceLocationId}
                                            onChange={(e) => {
                                                setServiceLocationId(Number(e.target.value))
                                                setServiceLocationAddress(locationOptions?.filter((loc: any) => loc?.value === Number(e.target.value))[0]?.address)
                                                setServiceLocationLink(locationOptions?.filter((loc: any) => loc?.value === Number(e.target.value))[0]?.locationlink)
                                            }}
                                            className="w-[300px] border border-gray-300 rounded-md p-3 text-sm outline-none focus:border-primary bg-white"
                                        >
                                            {locationOptions.map((loc: any, index: number) => (
                                                <option key={index} value={loc?.value}>
                                                    {loc?.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <a
                                        href={serviceLocationLink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-xs text-primary inline-block underline hover:cursor-pointer mt-2"
                                    >
                                        <span>{serviceLocationAddress}</span>
                                    </a>
                                </div>
                            )
                        }

                        <div className="border-b pb-4 space-y-4">

                            {/* Title */}
                            <span className="text-sm font-semibold text-gray-800">
                                Choose Date & Time
                            </span>
                            {
                                blockDaysCheckWarning && (
                                    <p className="text-[12px] mt-2 bg-[#FEDFDD] text-[#D92D20] text-left rounded-lg py-2 px-6">
                                        {blockDaysCheckWarning}
                                    </p>
                                )
                            }
                            <div className="grid grid-cols-1 gap-4  md:grid-cols-2">
                                <div>
                                    <label className="text-sm font-medium text-gray-700 block mb-1">
                                        Appointment Date*
                                    </label>
                                    <CustomDateField
                                        value={serviceDate}
                                        onChange={(value) => { setServiceDate(value) }}
                                        minDate={new Date().toISOString().split("T")[0]}
                                        className="w-full border border-gray-300 rounded-xl px-3 py-4 text-sm outline-none focus:border-primary"
                                        required={true}
                                    />

                                </div>

                                {/* Time */}
                                <div>
                                    <label className="text-sm font-medium text-gray-700 block mb-1">
                                        Appointment Time*
                                    </label>
                                    <input
                                        type="time"
                                        className="w-full border border-gray-300 rounded-xl px-3 py-4 text-sm outline-none focus:border-primary"
                                        value={serviceTime}
                                        onChange={(e) => setServiceTime(e.target.value)}
                                        required
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="w-full border-b py-4">
                            <span className="text-sm font-semibold text-gray-800">
                                Service
                            </span>
                            <div className="w-full mt-2">
                                {
                                    serviceOptionsLoaded && (
                                        servicesOptions?.map((service: any, index: number) => (
                                            <div key={index} className="mb-2">
                                                <div
                                                    className={`flex justify-between items-center bg-transparent px-2 py-3 mt-1 w-full h-full min-h-max rounded-lg shadow-sm border`}
                                                >
                                                    <div className="flex gap-1.5 ">
                                                        <span className={`text-[14px] font-semibold`}>
                                                            {service?.serviceName}
                                                        </span>
                                                    </div>

                                                    <div className={`px-3 py-3 flex gap-1.5 items-center border font-semibold rounded text-sm`}>
                                                        <input
                                                            type="checkbox"
                                                            className="cursor-pointer"
                                                            checked={selectedServices.some(
                                                                (s: any) => s.id === service.serviceID
                                                            )}
                                                            onChange={() => toggleService(service)}
                                                        />

                                                        <span className="text-sm font-medium">
                                                            {"$" + parseFloat(service?.price)?.toFixed(2)}
                                                            {service?.requiresTireCount ? "/Tire" : ""}
                                                        </span>
                                                    </div>
                                                </div>

                                            </div>
                                        ))
                                    )
                                }
                            </div>

                            {
                                !serviceOptionsLoaded && (
                                    <div className="flex justify-center items-center py-4">
                                        <div className="animate-spin h-8 w-8 border-2 border-primary border-t-transparent rounded-full mx-auto" />
                                    </div>

                                )
                            }
                        </div>


                        <div className="flex mt-6">
                            <button
                                type="button"
                                className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                onClick={() => { handleNext() }}
                            >
                                Next
                            </button>
                        </div>



                    </div>
                </div>
            </div>
        </div>
    )
}